import { useEffect } from 'react';
import { BRAND } from '@/config/brand';

/**
 * One <title> per route (CEO-4): "<page> · XDial". The previous title comes
 * back when the page unmounts.
 */
export function documentTitle(page?: string | null): string {
  return page ? `${page} · ${BRAND.name}` : BRAND.name;
}

export function useDocumentTitle(page?: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = documentTitle(page);
    return () => { document.title = previous; };
  }, [page]);
}
